<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Cidadãos CNS inválido"
            description="Cidadãos que precisam atualizar o CNS"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <tabela-cadastros-vuetfy
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            @filterSearch="filterSearch($event)"
          ></tabela-cadastros-vuetfy>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { mapState } from 'vuex'
import utils from '@/mixins/utils.js'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'

export default {
  name: 'CidadaosCnsInvalidos',
  components: {
    Menu,
    Footer,
    SectionTitle,
    TabelaCadastrosVuetfy,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    ...mapState(['user']),
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipes: '',
      equipe: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      cadastros: [],
      cadastrosOriginais: [],
      filterSearchTable: false,
    }
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    async buscarDadosIniciais() {
      try {
        this.loading = true

        let cidadados_cns_invalidos = await this.$api.get(
          '/app/cidadaos-cns-invalidos/' +
            this.cod_ibge +
            '/' +
            this.$store.state.nu_ine
        )
        this.cadastros = []
        this.cadastros = cidadados_cns_invalidos.data
        this.cadastrosOriginais = cidadados_cns_invalidos.data
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
